import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableString } from '../utils/wire-value-utils';

/**
 * A customer of the organization, built from the hub's customer JSON (`data-models/customer.ts`).
 * Customers own fields, which are sprayed during operations.
 *
 * Read-modify-write rule: writable fields the hub didn't send stay `undefined` (an explicit `null` stays `null`),
 * so a form built from a customer can't blank a value. Display fallbacks belong in templates.
 */
export class Customer extends Base {
  // Writable fields
  name?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  phone?: string | null;
  email?: string | null;
  notes?: string | null;

  // Read-only
  organizationId?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.name = nullableString(source['name']);
    this.address = nullableString(source['address']);
    this.city = nullableString(source['city']);
    this.state = nullableString(source['state']);
    this.zip = nullableString(source['zip']);
    this.phone = nullableString(source['phone']);
    this.email = nullableString(source['email']);
    this.notes = nullableString(source['notes']);
    this.organizationId = nullableString(source['organizationId']);
  }
}
